// src/guide/fiches_techniques/guide_fiches_techniques.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_fiches_techniques(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();
  document.getElementById("categorie")
    ? "categorie"
    : document.querySelector('[id^="pv_id_"][id$="_0_header_action"]').click();

  tour.addStep({
    title: translations.fiches_techniques.page.titre,
    text: translations.fiches_techniques.page.texte,
    attachTo: {
      element: `#${(document.getElementById("page").parentElement.id =
        "page_parent")}`,
      on: "",
    },
    canClickTarget: false,
    buttons: [
      {
        action() {
          document.getElementById("categorie")
            ? "categorie"
            : (document.querySelector(
                '[id^="pv_id_"][id$="_0_header_action"]'
              ).id = "categorie");
          document.getElementById("categorie").click();
          setTimeout(() => {
            tour.next();
          }, 500);
        },
        text: translations.boutons.suivant,
      },
    ],
  });

  tour.addStep({
    title: translations.fiches_techniques.fichier.titre,
    text: translations.fiches_techniques.fichier.texte,
    attachTo: {
      element: `#${
        document.getElementById("categorie")
          ? (document
              .getElementById("categorie")
              .parentElement.parentElement.lastChild.firstChild.querySelector(
                ".p-datatable"
              ).children[0].children[0].children[1].children[0].id = "fichier")
          : (document
              .querySelector('[id^="pv_id_"][id$="_0_header_action"]')
              .parentElement.parentElement.lastChild.firstChild.querySelector(
                ".p-datatable"
              ).children[0].children[0].children[1].children[0].id = "fichier")
      }`,
      on: "top",
    },
    canClickTarget: false,
    buttons: [
      {
        action() {
          tour.cancel();
          return tour.start();
        },
        classes: "shepherd-button-reset",
        text: translations.boutons.recommencer,
      },
      {
        action() {
          {
            document
              .getElementById(
                `${
                  document.getElementById("categorie")
                    ? "categorie"
                    : (document.querySelector(
                        '[id^="pv_id_"][id$="_0_header_action"]'
                      ).id = "categorie")
                }`
              )
              .click();
            setTimeout(() => {
              tour.back();
            }, 20);
          }
        },
        text: translations.boutons.precedent,
      },
      {
        action() {
          {
            document
              .getElementById(
                `${
                  document.getElementById("categorie")
                    ? "categorie"
                    : (document.querySelector(
                        '[id^="pv_id_"][id$="_0_header_action"]'
                      ).id = "categorie")
                }`
              )
              .click();
            setTimeout(() => {
              tour.complete();
            }, 20);
          }
        },
        text: translations.boutons.terminer,
      },
    ],
  });

  tour.start();
}
